import { apiAuth } from "../../http";

export const postPost = async (body: any): Promise<any> => {
  const response = apiAuth()
    .post("/posts", body, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then(({ data }) => data);
  return response;
};
